import { UpdateCustomerCommand } from "@/models/club";
import { useMutation } from "@tanstack/react-query";
import customerService from "..";

function useUpdateCustomer() {
  return useMutation({
    mutationFn: (command: UpdateCustomerCommand) => {
      return customerService.editCustomer(command);
    },
  });
}

export default useUpdateCustomer;
